import { Theme } from '@mui/material/styles'
export const getTruncatedStyles = (theme: Theme) => ({
  truncate: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    paddingRight: theme.spacing(0.5),
  },
})
